import React, { useEffect, useState } from 'react';
import type { ICellRendererParams } from 'ag-grid-community';
import { RootState, useDispatch, useSelector } from '../../redux/store';

/**
 * ユーザIDからemailを表示するレンダラ
 * @param params: ICellRendererParams
 * @returns React.ReactElement
 */
const ApproverEmailCellRenderer = (params: ICellRendererParams): React.ReactElement => {
  // console.log(params);
  const userId: string = params.value;
  const { adminPowerUsers } = useSelector((state: RootState) => state.user);
  const [userEmail, setUserEmail] = useState<string>('');

  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  // }, []);

  useEffect(() => {
    if (adminPowerUsers !== undefined) {
      const email: string | undefined = adminPowerUsers.admin.find((user) => user.id === userId)?.email;
      setUserEmail(email ?? userId);
    }
  }, [adminPowerUsers]);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return <div className="approver-email">{userEmail}</div>;
};

export default ApproverEmailCellRenderer;
